export interface PdfFieldValue {
  signedAttachmentId: string;
}

/** The signed copy's media id, or ''. A bare string value is the unsigned schema attachment, never a signed copy. */
export const getSignedAttachmentId = (value: unknown): string => {
  if (!value || typeof value !== 'object') return '';
  const id = (value as Partial<PdfFieldValue>).signedAttachmentId;
  return typeof id === 'string' ? id : '';
};
